<script lang="ts">
  import { createEventDispatcher } from "svelte";

  import Text from "./Text.svelte";

  export let disabled = false;

  let addressInput: HTMLInputElement;
  let address: string = "";
  let error = "";

  const clear = () => {
    address = "";
    error = "";
  };

  const dispatch = createEventDispatcher<{ update: { address: string } }>();

  $: dispatch("update", { address });
</script>

<label>
  <Text ocd color="transparency-dark" size="medium-large">email address</Text>
  <!-- disable safari's autocorrect and autocapitalize so that it doesn't randomly "fix" email
      addresses -->
  <input
    class="text-larger"
    type="email"
    required={address.length !== 0}
    bind:this={addressInput}
    bind:value={address}
    on:blur={(e) => {
      error = addressInput.checkValidity() ? "" : "email address invalid";
    }}
    placeholder="accounting@restaurant.com"
    autocorrect="off"
    autocapitalize="off"
    {disabled}
  />
</label>
{#if error}
  <div class="error">
    <div class="icon-container">
      <img src="static/assets/icons/icon-info.svg" alt="info" width={11} height={11} />
    </div>
    <div class="error-text">
      <Text ocd>{error}</Text>
    </div>
  </div>
{/if}

<style>
  input {
    width: 100%;
    border: 0px;
    background-color: #fff;
    outline-width: 0;
    padding-bottom: 4px;
  }

  input[type="email"]::placeholder {
    color: var(--rekki-transparency-dark);
  }

  label {
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 23px 18px 18px;
    /*margin-left: 10px;*/
    background-color: #fff;
    border-radius: 20px;
    z-index: 99;
    gap: 8px;
    height: 112px;
    box-sizing: border-box;
  }

  .error {
    background-color: var(--rekki-warning);
    margin-top: 8px;
    border-radius: 8px;
    padding: 9px 10px;
    display: flex;
    flex-direction: row;
  }

  .error-text {
    margin-top: 1px;
  }

  .icon-container {
    width: 20px;
    height: 20px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--rekki-light);
    margin-right: 8px;
  }
</style>
